import { matchPath } from "react-router-dom";
import { ROUTES } from "dmsbasereact";
import { APP_ROUTES } from "./NamedRoutes";

const routeMappings = [
  { pattern: "/", slug: "home" },
  { pattern: ROUTES.Home, slug: "home" },

  // Dispensing
  { pattern: APP_ROUTES.Dispensing, slug: "dispensacao" },
  { pattern: APP_ROUTES.DispensingHistory, slug: "dispensacao-historico" },
  { pattern: APP_ROUTES.Return, slug: "devolucao" },

  // User Management
  { pattern: APP_ROUTES.Patient, slug: "gestao-pacientes" },
  { pattern: APP_ROUTES.UserManagement, slug: "gestao-usuarios" },
  { pattern: ROUTES.User, slug: "gestao-usuarios" },
  { pattern: ROUTES.Role, slug: "gestao-perfis" },

  // Institution
  { pattern: APP_ROUTES.Institution, slug: "gestao-instituicoes" },
  { pattern: APP_ROUTES.InstitutionApproval, slug: "aprovacao-instituicoes" },

  // Training
  { pattern: APP_ROUTES.TrainingVideo, slug: "treinamentos" },
  { pattern: APP_ROUTES.Training, slug: "treinamentos-gestao" },
  { pattern: APP_ROUTES.TrainingGroup, slug: "grupos-treinamento" },
  { pattern: APP_ROUTES.TrainingMaterial, slug: "material-treinamento" },
  { pattern: APP_ROUTES.InstitutionalGroup, slug: "grupos-institucionais" },

  // Check-in/Check-out
  { pattern: APP_ROUTES.CheckinCheckout, slug: "checkin-checkout" },

  // Imports
  { pattern: APP_ROUTES.DoctorImport, slug: "importacao-medicos" },
  { pattern: APP_ROUTES.PharmacistImport, slug: "importacao-farmaceuticos" },
  { pattern: APP_ROUTES.PatientImport, slug: "importacao-pacientes" },
  { pattern: APP_ROUTES.InstitutionsImport, slug: "importacao-instituicoes" },

  // Production Data
  { pattern: ROUTES.Product, slug: "producao" },

  // System Configuration
  { pattern: ROUTES.SystemSettings, slug: "configuracoes-sistema" },
  { pattern: APP_ROUTES.SapConfiguration, slug: "configuracao-sap" },
  { pattern: APP_ROUTES.SapCommunication, slug: "comunicacao-sap" },
  { pattern: APP_ROUTES.ApiKeyManagement, slug: "gestao-api-keys" },

  // Search
  { pattern: APP_ROUTES.Search, slug: "busca" },

  // Alert System
  { pattern: "/dms-alert", slug: "sistema-alertas" },
  { pattern: "/dms-alert/active-alerts", slug: "alertas-ativos" },
];

export const resolveManualSlug = (pathname = "/") => {
  if (!pathname || pathname === "/") {
    return "home";
  }

  for (const { pattern, slug } of routeMappings) {
    if (!pattern) continue;
    const match = matchPath(
      { path: pattern, end: pattern === "/" || !pattern.includes(":") },
      pathname
    );
    if (match) {
      return slug;
    }
  }

  return "index";
};
